import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const ItalicIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType & { backgroundColor?: string }) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.33332 4H19.3333M4.66666 20H16.6667M13.3333 4L10.6667 20"
        stroke={iconColor}
        strokeWidth="1.5"
      />
    </Box>
  );
};
